import { parseJSON } from "./date";

function ExtraLinksObject(obj) {
  return {
    ...obj._links,
    ...obj._extra,
    ...obj
  };
}

export function ApiObject(text) {
  const obj = parseJSON(text);

  return ExtraLinksObject(obj);
}

// TODO Think about this signature
export function ApiList(text, model, paginated = true) {
  let Model = model || ExtraLinksObject;
  const data = parseJSON(text);

  if (paginated) {
    return {
      ...data,
      results: data.results.map(e => Model(e))
    };
  } else {
    return data.map(e => Model(e));
  }
}
